module.exports = __webpack_public_path__ + "img/map-estate-img.21798541.png";